<template>
  <div class="container" ref="wrapper">
    <van-loading class="loading" color="#9d1d22" text-color="#9d1d22" v-if="loading" size="24px">加载中...</van-loading>
    <div v-if="loading == false">
      <van-sticky>
        <van-nav-bar :title="articles.name" left-arrow @click-left="goBack()">
          <template #right>
            <div @click="toHome()">
              <van-icon name="wap-home-o" size="18" />
              <div style="float: right; margin-left: 5px; font-size: 15px">
                首页
              </div>
            </div>
          </template>
        </van-nav-bar>
      </van-sticky>

      <van-row style="margin: 5px">
        <van-col span="12">
          <div class="product-proptext">零售价格: {{ articles.price }}</div>
        </van-col>
        <van-col span="12">包装规格: {{ articles.packSize }}</van-col>
      </van-row>
      <van-row style="margin: 5px">
        <van-col span="12">
          <div class="product-proptext">香型: {{ articles.flavor }}</div>
        </van-col>
        <van-col span="12">酒精度: {{ articles.alcohol }}</van-col>
      </van-row>

      <van-row style="margin: 5px">
        <van-col span="24">
          <div class="product-proptext">
            <van-tag round size="large" color="#9d1d22" @click="shareBBS()">点击分享你的经验</van-tag>
          </div>
        </van-col>
      </van-row>

      <van-tabs v-model="activeName" sticky :before-change="tabbeforeChange">

        <van-tab title="产品介绍" name="a">
          <van-row>
            <van-col span="24">
              <div class="acontent" v-html="articles.detailsHtml"></div>
            </van-col>
          </van-row>
        </van-tab>
        <van-tab title="产品图片" name="b">
          <van-row>
            <van-col span="24">
              <div class="acontent" v-html="articles.imageHtml"></div>
            </van-col>
          </van-row>
        </van-tab>
        <van-tab title="产品清单" name="g">
          <van-row>
            <van-col span="24">
              <div class="acontent" v-html="articles.imageHtmlQDPJ"></div>
            </van-col>
          </van-row>
        </van-tab>
        <van-tab title="市场活动" name="c">
          <van-row>
            <van-col span="24">
              <ArticleList :type="106" :productId="this.bbs.page.filterData.productId"></ArticleList>
            </van-col>
          </van-row>
        </van-tab>
        <van-tab title="优享图文" name="f">
          <van-row style="margin: 5px">
            <van-col span="12">
              <div class="product-proptext">原价: {{ ScoreProduct.cash }}</div>
            </van-col>
            <van-col span="12">售价: {{ ScoreProduct.score }}</van-col>
          </van-row>
          <van-image width="100%" :src="imgurl" :key="index" v-for="(imgurl, index) in ScoreProductImageList" />
          <van-col span="24">
            <div class="acontent" v-html="ScoreProduct.detailsHtml"></div>
          </van-col>
        </van-tab>
        <van-tab title="技能加持" name="d">
          <van-row>
            <van-col span="24">
              <ArticleList :type="102" :productId="this.bbs.page.filterData.productId"></ArticleList>
            </van-col>
          </van-row>
        </van-tab>

        <van-tab title="心声分享" name="e">
          <van-row>
            <van-col span="24">
              <van-list v-model="bbs.upLoading" :finished="bbs.finished" @load="bbsonLoad" finished-text="没有更多了">
                <van-cell-group v-for="item in bbs.detail" :key="item.id.toString()">
                  <van-cell @click="toDetail(item.id.toString())" :border="false">
                    <van-col span="3">
                      <van-image style="float: left" round width="41px" height="41px" fit="fill"
                        :src="item.headImgurl" />
                    </van-col>

                    <van-col span="11">
                      <div style="
                          float: left;
                          color: #069;
                          font-size: 16px;
                          font-weight: bold;
                          width: 100%;
                        ">
                        {{ item.trueName }}
                      </div>

                      <div style="float: left; color: #696969">
                        {{ item.creationTime | relTime }}
                      </div>
                      <div style="float: left; color: #696969; margin-left: 13px">
                        浏览{{ item.readCount }}人次
                      </div>
                    </van-col>
                    <van-col span="10"> </van-col>

                    <van-col span="2"></van-col>
                    <van-col span="22">
                      <div>
                        <h3 style="display: inline-block">{{ item.title }}</h3>

                        &nbsp;
                        <van-tag v-if="item.audioUrl.length > 5" mark plain color="#9d1d22">有音频
                        </van-tag>
                        &nbsp;&nbsp;
                        <van-tag v-if="item.videoUrl.length > 5" mark plain color="#9d1d22">有视频
                        </van-tag>
                      </div>
                      <div class="bbsacontent">
                        <div class="bbscontent" v-html="item.detailsHtml"></div>
                        <div class="showqw" style="
                            position: absolute;
                            height: 30px;
                            color: rgb(0, 102, 153);
                            font-size: 16px;
                            font-weight: bold;
                            width: 100%;
                            bottom: 0px;
                            background: white;
                          ">
                          点击查看全文
                        </div>
                      </div>
                    </van-col>
                  </van-cell>
                </van-cell-group>
              </van-list>
            </van-col>
          </van-row>
        </van-tab>


      </van-tabs>
      <!--市场宣传 下载pdf 或ppt 文件-->
      <van-row style="margin: 5px" v-if="articles.fileUrl != undefined && articles.fileUrl.length > 30">
        <van-button type="info" size="large" round block @click="downLoadFile">下载原文件</van-button>
      </van-row>
      <comment :CommentPage="CommentPage"></comment>
    </div>
  </div>
</template>

<script>
import { getProductInfo, GetRelatedScoreProduct } from "@/api/product";
import { getBbsList } from "@/api/bbs";
import Comment from "../components/comment";
import ArticleList from "../components/articleList";
import { getDownLoadFilefromUrl } from "@/api/clouddisk";
import { saveAs } from "file-saver";
import { Toast } from 'vant';


export default {
  name: "znproductdetail",
  data() {
    return {
      scroll: 0,
      loading: true,
      activeName: "a",

      articles: {
        name: "产品名称",
      },

      CommentPage: {
        current: 1,
        pageSize: 10,
        filterData: {
          itemId: "",
          itemType: 2,
        },
      },
      ScoreProduct: {

      },

      bbs: {
        keyword: "",
        upLoading: false,
        finished: false,
        detail: [],
        topicName: "",
        productName: "",
        page: {
          sorterType: 0,
          current: 1,
          pageSize: 10,
          filterData: {
            typeId: 0,
            productId: "00000000-0000-0000-0000-000000000000",
            topicId: 0,
            title: "",
          },
        },
      },
    };
  },
  components: {
    Comment,
    ArticleList,
  },

  computed: {

    ScoreProductImageList() {
      //
      if (this.ScoreProduct.productImageUrls) {
        try {
          // 使用JSON.parse方法将字符串转换为数组
          const arr = JSON.parse(this.ScoreProduct.productImageUrls);
          return arr;
        } catch (error) {
          return [];
        }
      }
      return [];
    },
  },
  activated() {
    //  window.scrollTo(0, this.scroll);
    //  alert( this.$refs.wrapper.scrollTop);
    try {
      this.$refs.wrapper.scrollTop = this.scroll;
    } catch (error) {
      console.log(error);
    }
  },
  created() {
    this.initData();
    this.onLoad();
  },
  updated() {
    this.showQW();
    this.addpreview();
  },

  watch: {
    $route(to, from) {
      console.log(to);

      if (to.path == "/product/detail") {
        console.log("watch");
        if (to.query != from.query) {
          this.loading = true;
          this.initData();
          this.onLoad();
        }
      }
    },
  },
  mounted() { },

  methods: {
    goBack() {
      if (this.$route.query.back) {
        this.$router.back();
      }
      else {
        this.$router.replace({ path: '/product/list' })
      }
    },
    toHome() {
      this.$router.replace({ path: "/" });
    },
    initData() {
      this.activeName = "a";
    },
    async onLoad() {
      let para = this.$route.query.para;
      if (para) {
        let aresult = await getProductInfo(para); //({ ...this.page })
        console.log(aresult);
        this.articles = aresult.data.data;
        document.title = this.articles.name;
        this.bbs.page.filterData.productId = this.articles.id;
        this.CommentPage.filterData.itemId = this.articles.id;
        this.loading = false;
      }
    },
    async shareBBS() {
      this.articles.id;

      this.$router.push({
        path: "/bbs/add",
        query: { productId: this.articles.id },
      });
    },
    async bbsonLoad() {
      this.bbs.upLoading = true;
      let aresult = await getBbsList({ ...this.bbs.page }); //({ ...this.page })
      this.bbs.detail.push(...aresult.data.data);

      this.bbs.upLoading = false;
      if (this.bbs.page.current * this.bbs.page.pageSize < aresult.data.total) {
        this.bbs.page.current++;
      } else {
        this.bbs.finished = true;
      }
    },
    async tabbeforeChange(index) {
      // 返回 false 表示阻止此次切换
      // if (index === "c") {
      //   let aresult = await getProductInfo();
      // }

      if (index === "f") {
        let sp = await GetRelatedScoreProduct(this.$route.query.para)
        if (sp.data.success) {
          this.ScoreProduct = sp.data.data;
        }
      }

      console.log(index);
      return true;
    },
    toDetail(id) {
      this.$router.push({
        path: "/bbs/detail",
        query: { para: id },
        back: true,
      });
    },
    showQW() {
      var listdiv = document.getElementsByClassName("bbsacontent");
      listdiv.forEach((element) => {
        if (element.childNodes.length == 2) {
          if (element.childNodes[0].clientHeight > 300) {
            element.childNodes[1].style.display = "block";
          } else {
            element.childNodes[1].style.display = "none";
          }
        }
      });
    },
    //加图片预览
    addpreview() {
      var listdiv = document.getElementsByClassName("acontent");
      listdiv.forEach((acontentdiv) => {
        var imgs = acontentdiv.getElementsByTagName("img");

        imgs.forEach((element) => {
          element.setAttribute("preview", this.articles.id);
        });
      });
      this.$previewRefresh();
    },

    setScroll() {
      let wrapperScrollTop = this.$refs.wrapper.scrollTop;
      console.log(this.$refs.wrapper);
      console.log(this.$refs.wrapper.scrollTop);
      //存储 scrollTop 的值
      this.scroll = wrapperScrollTop;
    },

    async downLoadFile() {
      if (this.isWenXin() && this.isMobile()) {
        Toast("微信中下载受限，请点击右上角三个点，在浏览器中打开下载源文件");
        return;
      }
      Toast("正在下载...");



      let fileObj = JSON.parse(this.articles.fileUrl);
      fileObj.forEach(async (item) => {

        var data = await getDownLoadFilefromUrl(item.response);


        saveAs(data.data, item.name);
      });
    },
    isWenXin: function () {
      if (navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1) {
        return true; // 是微信端
      } else {
        return false;
      }
    },
    isMobile: function () {
      return navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
    },
  },
};
</script>


<style lang="less" scoped>
.loading {
  text-align: center;
}

.container {
  height: 100%;
  overflow-y: auto;
  box-sizing: border-box;
}

.acontent {
  /deep/ img {
    max-width: 100% !important;
    display: block;
    border: 0;
  }

  /deep/ video {
    max-width: 100% !important;
  }

  /deep/ p {
    padding: revert;
    margin: revert;
  }
}

.product-proptext {
  margin-left: 20px;
}

.bbscontent {
  height: 100%;
}

.bbsacontent {
  max-height: 300px;
  overflow: hidden;
  text-overflow: ellipsis;

  /deep/ ol {
    list-style: decimal !important;
    margin-left: 25px;
  }

  /deep/ ol li {
    list-style-position: outside;
  }

  /deep/ img {
    max-width: 33% !important;
    display: block;
    border: 0;
  }

  /deep/ video {
    max-width: 100% !important;
  }
}
</style>